// extracted by mini-css-extract-plugin
module.exports = {"password-modal":"EditUserPage_password-modal__4j-Ac"};